import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivityStreamEntityType, ActivityStreamLoadConfig } from '@coin/shared/activity-stream/util';

@Component({
  selector: 'coin-activity-stream-dialog',
  templateUrl: './activity-stream-dialog.component.html',
  styleUrls: ['./activity-stream-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActivityStreamDialogComponent {
  data = inject<{
    loadConfig: ActivityStreamLoadConfig;
    type: ActivityStreamEntityType;
  }>(MAT_DIALOG_DATA);
  private dialog = inject<MatDialogRef<ActivityStreamDialogComponent>>(MatDialogRef);

  reload$ = new Subject<void>();

  constructor() {
    this.reload$.next();
  }

  public close(): void {
    this.dialog.close();
  }
}
